import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EmailCredentials, EmailSecurityOptions} from '@app/shared/models/credentials';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { SmpUtils } from '@app/core/helpers/utilities';
import { BaseList } from '@app/shared/models/list';
import { EmailProvider } from '@app/shared/models/email-provider';
import { CredentialsService } from '@app/core/services/credentials.service';
import { DRResponse } from '@app/shared/models/response';

@Component({
    selector: 'email-credentials',
    templateUrl: './email-credentials.component.html',
    styleUrls: ['./email-credentials.component.scss']
})
export class EmailCredentialsComponent extends TwoWayBoundComponent<EmailCredentials>
                                       implements OnInit, OnChanges {

    @Input()
    public emailProviders: BaseList<EmailProvider>;

    @Output()
    public save = new EventEmitter<void>();

    @Output()
    public cancel = new EventEmitter<void>();

    @Output()
    public testMailResponse = new EventEmitter<DRResponse<any>>();

    public selectedProvider: EmailProvider;
    public securityOptions: EmailSecurityOptions[];
    private testMailInProgress: boolean;

    get emailCredentials(): EmailCredentials {
        return this.bananaBox;
    }

    get disableTestEmailBtn(): boolean {
        return this.testMailInProgress || !this.emailCredentials.credentialsComplete();
    }

    constructor(protected credentialsService: CredentialsService) {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
        this.selectedProvider = this.emailProviders.items.find(provider => provider.provider === this.emailCredentials.provider);
        this.securityOptions = SmpUtils.enumToStringArray(EmailSecurityOptions) as EmailSecurityOptions[];
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.bananaBox && changes.bananaBox.currentValue && changes.bananaBox.previousValue && changes.bananaBox.currentValue.provider !== changes.bananaBox.previousValue.provider) {
            this.selectedProvider = this.emailProviders.items.find(provider => provider.provider === this.emailCredentials.provider);
        }
    }

    public onProviderChange(): void {
        this.emailCredentials.provider = this.selectedProvider.provider;
        this.emailCredentials.host = this.selectedProvider.host;
        this.emailCredentials.security = this.selectedProvider.security;
        this.emailCredentials.port = this.selectedProvider.port;
        this.onChange();
    }

    public sendTestEmail(): void {
        this.testMailInProgress = true;
        this.credentialsService.sendTestEmail(this.emailCredentials)
                               .subscribe((result) => {
            this.testMailResponse.emit(result);
            this.testMailInProgress = false;
        }, err => {
            this.handleError(err);
            this.testMailInProgress = false;
        });
    }

    public saveCredentials(): void {
        this.save.emit();
    }

    public cancelEditing(): void {
        this.cancel.emit();
    }
}
